import UserAuth from './user-auth';

export default UserAuth;
